import List from '../../../utils/list';

const mutation = {
  RESET_DATA(state) {
    state.all = [];
    state.filter = {};
    state.filter.page = 1;
    state.isDocksLoading = false;
    state.isGatesLoading = false;
    state.isPaginatinng = false;
    state.isLoading = true;
    state.gates = {};
    state.depot = {};
    state.docks = {};
    state.isUploading = false;
    state.isDownloading = false;
    state.hasEmpty = false;
  },

  ALL_DEPOT(state, data) {
    const result = (state.filter.page > 1) ? state.all.concat(data) : data;
    state.all = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },

  CURRENT_DEPOT(state, data) {
    state.depot = data;
  },

  DEPOTS_LOADING(state, status) {
    state.isLoading = status;
  },

  UPDATE_DEPOT_DATA(state, { data }) {
    const result = List.update(state.all, data);
    state.all = result;
    if (state.depot.id === data.id) {
      state.depot = data;
    }
  },

  ADD_DEPOT(state, { data }) {
    const result = List.new(state.all, data);
    state.all = result;
  },

  GATES_LOADING(state, status) {
    state.isGatesLoading = status;
  },

  DEPOT_GATE(state, gates) {
    state.gates = gates;
  },

  DOCKS_LOADING(state, status) {
    state.isDocksLoading = status;
  },

  DEPOT_DOCKS(state, docks) {
    state.docks = docks;
  },

  ADD_GATE(state, { data }) {
    const result = List.new(state.gates, data);
    state.gates = result;
  },

  UPDATE_GATE(state, { data }) {
    const result = List.update(state.gates, data);
    state.gates = result;
  },

  ADD_DOCK(state, { data }) {
    const result = List.new(state.docks, data);
    state.docks = result;
  },

  UPDATE_DOCK(state, { data }) {
    const result = List.update(state.docks, data);
    state.docks = result;
  },

  UPLOAD_STATUS(state, status) {
    state.isUploading = status;
  },

  DOWNLOAD_STATUS(state, status) {
    state.isDownloading = status;
  },

  SET_PAGE(state, data) {
    state.filter.page = data;
  },

  DEPOT_PAGINATING(state, data) {
    state.isPaginatinng = data;
  },
};

export default mutation;
